import Tooltip from "rc-tooltip";
import React from "react";

const overlay = (
    <div>
        <b>Запросить обратный рейс</b>
        <br />
        Запрос на заявку отправляется в сервис Загрузки <br />и будет виден всем грузоотправителям и ТЭК
    </div>
);

const ForwardingOrderInfo = () => {
    return (
        <Tooltip overlay={overlay} placement="right">
            <span className="show-bid__section-header--tooltip">?</span>
        </Tooltip>
    );
};

ForwardingOrderInfo.overlay = overlay;

export default ForwardingOrderInfo;
